import Avatar from "components/Canvas/Graphics/Assets/Avatar";

class AvatarManager {
  #context;

  constructor(context) {
    this.#context = context;
  }

  createDefaultAvatar() {
    if (this.#context.isAvatarReady) return;
    const avatar = this.#context.avatar;
    avatar.create();
    avatar.model.userData.playInfo = {isAlive: true};
    this.#context.scriptLauncher.setApis(avatar.model);
    return avatar.model;
  }
}

export default Object.freeze(AvatarManager);
